'use strict';
import * as joint from 'jointjs';
import * as erd from './Helpers/erd.js';
import Entity from './Model/GraphModel/Entity.js';
import Relation from './Model/GraphModel/Relation.js';
import Property from './Model/GraphModel/Property.js';
import Connector from './Model/GraphModel/Connector.js';
import Connection from './Model/GraphModel/Connection.js';
import Query from './Model/AnnotatedGraphModel/Query.js';
import SavedGraph from './Model/SavedGraph.js';
import LinkAnnotation from './Model/AnnotatedGraphModel/LinkAnnotation.js';
import JSONSchema from './Model/NRSModel/JSONSchema.js';
import NormalType from './Model/NRSModel/NormalType.js';
import ArrayType from './Model/NRSModel/ArrayType.js';
import ObjectType from './Model/NRSModel/ObjectType.js';
import Table from './Model/CodeGeneraion/Table.js';
import DBIndex from './Model/CodeGeneraion/DBIndex.js';
import TableProperty from './Model/CodeGeneraion/TableProperty.js';
import Helper from './Helpers/Helper.js';

// Joint params
const graph = new joint.dia.Graph();
const paper = new joint.dia.Paper({
  el: document.getElementById('draw-paper'),
  width: 'inherit',
  height: 'inherit',
  model: graph,
  linkPinning: true,
  highlighting: true,
  snapLabels: true,
  drawGrid: true,
  interactive: { linkMove: true, labelMove: true },
  defaultConnectionPoint: function (line, view) {
    var element = view.model;
    return element.getConnectionPoint(line.start) || element.getBBox().center();
  },
});

const highlighter = joint.V('path', {
  stroke: '#e9fc03',
  'stroke-width': '2px',
  fill: 'transparent',
  'pointer-events': 'none',
});

//Add Entity Form
const entityNameField = document.querySelector('.form__input--entityname');
const addEntityForm = document.querySelector('.form--addentity');

//Add property Form
const propertyName = document.querySelector('.form__input--property');
const chooseEntityOrRelationProperty = document.querySelector(
  '.form__entityselection--property'
);
const addPropertyFrom = document.querySelector('.form__newproperty--property');
const optionalCheckBox = document.getElementById('optionalCheck');

//Primary Key
const primaryKeyForm = document.querySelector('.form__newproperty--PrimaryKey');
const chooseEntityOrRelationPrimary = document.querySelector(
  '.form__entityselection--PrimaryKey'
);
const propertiesDiv = document.getElementById('EntityProps');

//Connection Form
const addConnectionFromField = document.querySelector(
  '.form__entityselection--from'
);
const addConnectionToField = document.querySelector(
  '.form__entityselection--to'
);
const addNewConnectionForm = document.querySelector(
  '.form__newproperty--connections'
);

//Upload Workload Form
const uploadWorkload = document.querySelector(
  '.form__newproperty--uploadworkload'
);

//Save Graph Form
const saveGraphForm = document.querySelector('.form__newproperty--save');

//load Graph Form
const loadGraphForm = document.querySelector('.form__newproperty--load');

//new Graph Form
const newGraphForm = document.querySelector('.form__newproperty--new');

//Schema Annotation Button
const schemaAnnotationButton = document.querySelector(
  '.form__btn--Annotate-Schema'
);

// NRS button
const nestedRelationalSchemaButton = document.querySelector('.form__btn--NRS');

//Code Generation Button
const codeGenerationButton = document.querySelector('.form__btn--CCG');

// NeededVariables
const dropDownlists = [
  chooseEntityOrRelationProperty,
  chooseEntityOrRelationPrimary,
  addConnectionFromField,
  addConnectionToField,
];

const graphData = [];
const workloads = [];
const linkAnnotations = [];
const allJSONSchema = [];
let selectedChild;
let annotate = false;

// Bind custom ones.
chooseEntityOrRelationPrimary.addEventListener('change', function (e) {
  e.preventDefault();
  const Id = chooseEntityOrRelationPrimary.value.split('|')[0];
  updatePrimaryKeyDiv(Id);
});

paper.on('blank:pointerdblclick', function () {
  selectedChild = null;
});

paper.on('cell:highlight', function (cellView) {
  let padding = 5;
  let bbox = cellView.getBBox({ useModelGeometry: true }).inflate(padding);

  highlighter.translate(bbox.x, bbox.y, { absolute: true });
  highlighter.attr(
    'd',
    cellView.model.getHighlighterPath(bbox.width, bbox.height)
  );

  joint.V(paper.viewport).append(highlighter);
});

paper.on('cell:unhighlight', function () {
  highlighter.remove();
});

paper.on('cell:pointerclick', function (cell) {
  selectedChild = cell.model;
});

graph.on('change:position', function (cell) {
  if (
    cell.attributes.type === 'erd.Key' ||
    cell.attributes.type === 'erd.Normal'
  ) {
    const property = graphData
      .flatMap(ent => ent.getProperties())
      .find(prop => prop.getId() === cell.id);
    property.setPosition(cell.attributes.position);
  } else if (cell.attributes.type === 'erd.Multivalued') {
    const connector = graphData
      .flatMap(ent => ent.getProperties())
      .map(prop => prop.getConnector())
      .filter(connector => connector)
      .find(connector => connector.getId() === cell.id);
    connector.setPosition(cell.attributes.position);
  } else {
    const entity = graphData.find(ent => ent.getId() === cell.id);
    if (!entity) return;
    entity.setPosition(cell.attributes.position);
  }
});

// Delete Cells listener
window.addEventListener('keydown', function (ev) {
  const key = ev.key;
  if (key === 'Backspace' && selectedChild) {
    if (!annotate) {
      // console.log(selectedChild);
      switch (selectedChild.attributes.type) {
        case 'erd.Multivalued':
          deleteConnectorCell(selectedChild.id);
          break;
        case 'erd.Normal':
          deleteNormalProp(selectedChild.id);
          break;
        case 'erd.Key':
          deletePrimaryProp(selectedChild.id);
          break;
        default:
          deleteEntityOrRelation(selectedChild.id);
          break;
      }
      selectedChild = null;
      console.log(graphData);
    } else {
      alert(
        'You cannot delete an object after anntotating the schema, please start another grapth.'
      );
    }
  }
});

// Helper Functions

const updatePrimaryKeyDiv = function (Id) {
  const properties = graphData
    .find(ent => ent.getId() === Id)
    .getProperties()
    .filter(prop => prop.getIsPrimary() === false);
  propertiesDiv.innerHTML = '';
  properties.forEach(prop => {
    const markup = `<label>
                      <input
                        id="optionalCheck"
                        name="${prop.getName()}"
                        type="checkbox"
                      />
                      ${prop.getName()}
                    </label>`;
    propertiesDiv.insertAdjacentHTML('beforeend', markup);
  });
};

const checkAddedData = function (type, entityName, propName = '') {
  const entity = graphData.find(
    ent => ent.getName().toLowerCase() === entityName.toLowerCase()
  );
  if (type === 'AddEntity/Relation') {
    if (entity) return false;
    else return true;
  } else if (type === 'AddProperty') {
    const prop = entity
      .getProperties()
      .find(prop => prop.getName().toLowerCase() === propName.toLowerCase());
    if (prop) return false;
    else return true;
  }
};

const updateDropDownlist = function (id, type, name) {
  const markup = `<option value="${id}|${type}">${
    type === 'Entity' ? 'E- ' : 'R- '
  }${name}</option>`;
  dropDownlists.forEach(el => {
    el.insertAdjacentHTML('beforeend', markup);
    el.value = '';
  });
  propertiesDiv.innerHTML = '';
};

const deleteItemFromDropdownLists = function (id, type) {
  dropDownlists.forEach(el => {
    el.querySelector(`option[value="${id}|${type}"]`).remove();
  });
};

const calculatePoint = function (position1, position2) {
  // console.log(position1, position2);
  return {
    x: Math.abs(position1.x + position2.x) / 2,
    y: Math.abs(position1.y + position2.y) / 2,
  };
};

const createGraphAnnotatedLink = function (linkAnnotation, from, to) {
  const link = new joint.shapes.standard.Link();
  const midPoint = calculatePoint(
    from.attributes.position,
    to.attributes.position
  );
  link.source(from);
  link.target(to);
  link.vertices([new joint.g.Point(midPoint.x, midPoint.y)]);
  // link.attr('line/stroke', 'orange');
  link.attr({
    line: { type: 'path', stroke: 'orange', strokeDasharray: '4 2' },
  });
  link.labels([{ attrs: { text: { text: linkAnnotation } } }]);
  link.addTo(graph);
};

const handleLinkAnnotations = function (linkAnnotation, from, to) {
  let annotation = linkAnnotations.find(
    annotate =>
      annotate.getFromEntity().getName() === from.getName() &&
      annotate.getToEntity().getName() === to.getName()
  );
  if (annotation) {
    const annotationArr = annotation.getLabel().split(',');
    if (!annotationArr.includes(linkAnnotation)) {
      annotationArr.push(linkAnnotation);
      annotation.setLabel(annotationArr.join(','));
    }
  } else {
    annotation = new LinkAnnotation(linkAnnotation, from, to);
    linkAnnotations.push(annotation);
  }
};

const downloadData = function (data, name = 'schema', ext = 'json') {
  let dataStr;
  if (ext === 'json') {
    dataStr =
      'data:text/json;charset=utf-8,' +
      encodeURIComponent(JSON.stringify(data));
  } else {
    dataStr = 'data:text/plain;charset=utf-8,' + encodeURIComponent(data);
  }
  const dlAnchorElem = document.getElementById('downloadAnchorElem');
  dlAnchorElem.setAttribute('href', dataStr);
  dlAnchorElem.setAttribute('download', `${name}.${ext}`);
  dlAnchorElem.click();
};

const addGraphAnnotation = function () {
  graphData.forEach(entity => {
    const graphEntity = graph.getCell(entity.getId());
    let newGraphEntity;
    if (entity.getIsAnnotated()) {
      newGraphEntity =
        entity instanceof Entity
          ? erd.createWeek(entity.getAnnotatedName(), entity.getPosition())
          : erd.createAnnotatedRelation(
              entity.getAnnotatedName(),
              entity.getPosition()
            );

      // Remove old Cell
      graph.removeCells([graphEntity]);

      //Add New Cell
      entity.setId(newGraphEntity.id);
      graph.addCell(newGraphEntity);

      entity.getConnections().forEach(connection => {
        const connectionEntity = graph.getCell(connection.getEntity().getId());
        erd
          .createLink(newGraphEntity, connectionEntity, graph)
          .set(erd.createLabel(connection.getType()));
      });
    }

    entity.getProperties().forEach(prop => {
      const graphProp = graph.getCell(prop.getId());
      if (prop.getIsAnnotated()) {
        graphProp.attributes.attrs.text.text = prop.getAnnotatedName();

        graph.removeCells([graphProp]);
        graph.addCell(graphProp);

        //add connector link
        const connectorData = prop.getConnector();
        if (connectorData) {
          const graphConnector = graph.getCell(connectorData.getId());
          erd.createLink(graphConnector, graphProp, graph);
        }

        if (prop.getConnectedEntity().getIsAnnotated())
          erd.createLink(newGraphEntity, graphProp, graph);
        else erd.createLink(graphEntity, graphProp, graph);
      } else {
        if (prop.getConnectedEntity().getIsAnnotated()) {
          erd.createLink(newGraphEntity, graphProp, graph);
        }
      }
    });
  });
};

const addLinkAnnotation = function () {
  linkAnnotations.forEach(annotation => {
    const fromData = graphData.find(
      entityData =>
        entityData.getName() === annotation.getFromEntity().getName()
    );
    const toData = graphData.find(
      entityData => entityData.getName() === annotation.getToEntity().getName()
    );
    createGraphAnnotatedLink(
      annotation.getLabel(),
      graph.getCell(fromData.getId()),
      graph.getCell(toData.getId())
    );
  });
};

const deleteConnectorCell = function (id) {
  //get Cell
  const deletedCell = graph.getCell(id);
  //get CellData
  const connector = graphData
    .flatMap(ent => ent.getProperties())
    .map(prop => prop.getConnector())
    .find(connector => connector && connector.getId() === id);

  if (connector && connector instanceof Connector) {
    const deletedCells = [deletedCell];
    connector.getPrimaryKeys().forEach(prop => {
      prop.setAsNotPrimary();

      const entityCell = graph.getCell(prop.getConnectedEntity().getId());
      const oldCell = graph.getCell(prop.getId());

      const newCell = erd.createNormalPropoerty(
        prop.getName(),
        prop.getPosition()
      );
      prop.setId(newCell.id);

      deletedCells.push(oldCell);

      graph.addCell(newCell);
      erd.createLink(entityCell, newCell, graph);
    });
    graph.removeCells(deletedCells);
  }
};

const deleteNormalProp = function (id) {
  //get Deleted Cell
  const deletedCell = graph.getCell(id);
  // get property Data
  const property = graphData
    .flatMap(ent => ent.getProperties())
    .find(prop => prop.getId() === id);

  if (property && property instanceof Property) {
    const deletedCells = [deletedCell];

    const propIndex = property
      .getConnectedEntity()
      .getProperties()
      .findIndex(prop => prop.getId() === property.getId());

    property.getConnectedEntity().getProperties().splice(propIndex, 1);
    graph.removeCells(deletedCells);
  }
};

const deletePrimaryProp = function (id) {
  // get property Data
  const property = graphData
    .flatMap(ent => ent.getProperties())
    .find(prop => prop.getId() === id);

  if (property && property instanceof Property) {
    deleteNormalProp(id);
    if (property.getConnector()) {
      const connector = property.getConnector();
      const ind = connector
        .getPrimaryKeys()
        .findIndex(prop => prop.getId() === property.getId());
      connector.getPrimaryKeys().splice(ind, 1);

      //Delete connector
      deleteConnectorCell(property.getConnector().getId());
    }
  }
};

const deleteEntityOrRelation = function (id) {
  const deletedCells = [graph.getCell(id)];

  const index = graphData.findIndex(ent => ent.getId() === id);

  if (index !== -1) {
    const entity = graphData[index];
    //delete properties and connectors
    while (entity.getProperties().length !== 0) {
      const prop = entity.getPropertyAt(0);
      if (prop.getIsPrimary()) {
        deletePrimaryProp(prop.getId());
      } else {
        deleteNormalProp(prop.getId());
      }
    }

    // delete connections
    entity.getConnections().forEach(connection => {
      const entityIndexInConnection = connection
        .getEntity()
        .getConnections()
        .findIndex(
          internalConnection =>
            internalConnection.getEntity().getId() === entity.getId()
        );
      connection
        .getEntity()
        .getConnections()
        .splice(entityIndexInConnection, 1);
    });

    // delete dropdownlist
    deleteItemFromDropdownLists(entity.getId(), entity.getType());

    // Delete
    graphData.splice(index, 1);
    graph.removeCells(deletedCells);
  }
};

// Handler Functions

const handelData = function (dataArr, type) {
  const data = Object.fromEntries(dataArr);

  if (type === 'AddEntity/Relation') {
    const { name, addedType } = data;
    if (checkAddedData(type, name)) {
      const addedCell =
        addedType === 'Entity'
          ? erd.createEntity(name)
          : erd.createRelation(name);

      const addedData =
        addedType === 'Entity'
          ? new Entity(addedCell.id, name, addedCell.attributes.position)
          : new Relation(addedCell.id, name, addedCell.attributes.position);

      graphData.push(addedData);
      //Draw the new Entity
      graph.addCell(addedCell);
      updateDropDownlist(addedCell.id, addedType, name);
    } else {
      addedType === 'Entity'
        ? alert('There is already added entity with the same name')
        : alert('There is already added relation with the same name');
    }
  } else if (type === 'AddProperty') {
    const { propName, propType, erName, optionalCheck } = data;
    const erId = erName.split('|')[0];
    const isOptional = optionalCheck ? true : false;

    const relatedEntityData = graphData.find(elm => elm.getId() === erId);
    if (checkAddedData(type, relatedEntityData.getName(), propName)) {
      const propCell = erd.createNormalPropoerty(propName);

      const propData = new Property(
        propCell.id,
        propName,
        propType,
        propCell.attributes.position,
        false,
        relatedEntityData,
        isOptional
      );
      relatedEntityData.addProperty(propData);

      // Draw ID Property
      graph.addCell(propCell);
      erd.createLink({ id: erId }, propCell, graph);

      const selectedPrimaryId =
        chooseEntityOrRelationPrimary.value.split('|')[0];
      if (selectedPrimaryId === relatedEntityData.getId()) {
        updatePrimaryKeyDiv(selectedPrimaryId);
      }
    } else {
      alert('The selected entity already has a property with same name');
    }
  } else if (type === 'AddConnection') {
    const { connectionType, fromEntity, toEntity } = data;
    const fromId = fromEntity.split('|')[0];
    const toId = toEntity.split('|')[0];

    const fromEn = graphData.find(el => el.getId() === fromId);
    const toEn = graphData.find(el => el.getId() === toId);

    const fromConn = new Connection(
      connectionType === '-' ? '' : connectionType,
      toEn
    );
    fromEn.addConnection(fromConn);

    const toConn = new Connection(
      connectionType === '-' ? '' : connectionType,
      fromEn
    );
    toEn.addConnection(toConn);

    if (fromEntity !== toEntity) {
      if (connectionType !== '-')
        erd
          .createLink({ id: fromId }, { id: toId }, graph)
          .set(erd.createLabel(connectionType));
      else erd.createLink({ id: fromId }, { id: toId }, graph);
    }
  }
  //check
  // console.log(graphData);
};

const handelPrimaryKeys = function (data) {
  console.log(data);
  const selectedId = data.erId.split('|')[0];
  const selectedEntity = graphData.find(ent => ent.getId() === selectedId);
  const objectKeys = Object.keys(data).filter(keyName => keyName !== 'erId');

  if (objectKeys.length === 0) return;
  else {
    // create connector cell in case of there are multiple keys
    let connectorCell, connectorData;
    if (objectKeys.length > 1) {
      connectorCell = erd.createPrimaryConnector();
      connectorData = new Connector(
        connectorCell.id,
        connectorCell.attributes.position
      );

      graph.addCell(connectorCell);
    }

    // Get All properties
    const neededProps = selectedEntity
      .getProperties()
      .filter(prop => objectKeys.includes(prop.getName()));

    neededProps.forEach(prop => {
      //set prop as a primary
      prop.setAsPrimaryKey();
      if (objectKeys.length > 1) {
        // add connection to connector cell
        connectorData.addNewPrimaryKey(prop);
        prop.setConnector(connectorData);
      }

      const oldCell = graph.getCell(prop.getId());
      const newCell = erd.createKey(prop.getName(), prop.getPosition());
      prop.setId(newCell.id);

      //removing Old Cell
      graph.removeCells([oldCell]);

      //adding new cell
      graph.addCell(newCell);
      erd.createLink(selectedEntity, newCell, graph);
      if (objectKeys.length > 1) {
        // create link
        erd.createLink(connectorCell, newCell, graph);
      }
    });
  }
  console.log(graphData);
};

// Event Listeners

addEntityForm.addEventListener('submit', function (e) {
  e.preventDefault();
  handelData([...new FormData(this)], 'AddEntity/Relation');
  entityNameField.value = '';
});

addPropertyFrom.addEventListener('submit', function (e) {
  e.preventDefault();
  handelData([...new FormData(this)], 'AddProperty');
  propertyName.value = '';
  optionalCheckBox.checked = false;
  chooseEntityOrRelationProperty.value = 'empty';
});

primaryKeyForm.addEventListener('submit', function (e) {
  e.preventDefault();
  const data = Object.fromEntries([...new FormData(this)]);
  handelPrimaryKeys(data);
  chooseEntityOrRelationPrimary.value = '';
  propertiesDiv.innerHTML = '';
});

addNewConnectionForm.addEventListener('submit', function (e) {
  e.preventDefault();
  handelData([...new FormData(this)], 'AddConnection');
});

uploadWorkload.addEventListener('submit', function (e) {
  e.preventDefault();
  workloads.splice(0, workloads.length);
  const data = Object.fromEntries([...new FormData(this)]);
  const file = data.workload;
  const reader = new FileReader();
  if (graphData.length === 0) {
    alert('Please add your entities first to the graph');
  } else {
    // Helper Function
    const getRelationString = function (
      queryNumber,
      mainEntityName,
      currentEntityName,
      rel,
      depth
    ) {
      if (depth === 0) {
        return '';
      } else {
        const currentEntity = graphData.find(
          ent => ent.getName() === currentEntityName && ent instanceof Entity
        );
        const relationEntity = currentEntity
          .getConnections()
          .find(connection => connection.getEntity().getName()[0] === rel[0])
          .getEntity();
        if (depth === 1) {
          const mainEntity = relationEntity
            .getConnections()
            .find(
              connection => connection.getEntity().getName() === mainEntityName
            )
            .getEntity();

          if (mainEntity) {
            handleLinkAnnotations(queryNumber, currentEntity, relationEntity);
            handleLinkAnnotations(queryNumber, relationEntity, mainEntity);
            return `${relationEntity.getName()}`;
          }
        } else {
          const newEntity = relationEntity
            .getConnections()
            .find(
              connection =>
                connection.getEntity() instanceof Entity &&
                connection.getEntity().getName() !== currentEntityName &&
                connection
                  .getEntity()
                  .getConnections()
                  .find(
                    rConnection =>
                      rConnection.getEntity() instanceof Relation &&
                      rConnection.getEntity().getName()[0] === rel[1]
                  )
            )
            .getEntity();

          if (newEntity)
            handleLinkAnnotations(queryNumber, currentEntity, relationEntity);
          handleLinkAnnotations(queryNumber, relationEntity, newEntity);
          return `${relationEntity.getName()}/${newEntity.getName()}/${getRelationString(
            queryNumber,
            mainEntityName,
            newEntity.getName(),
            rel.slice(1),
            depth - 1
          )}`;
        }
      }
    };

    const createObject = function (
      queryNumber,
      mainEntity,
      params,
      rel = '!',
      base = true
    ) {
      let retArr = [];
      const paramsArr = params.split('|');
      const entityName = paramsArr[0].split('(')[0];
      paramsArr.forEach(param => {
        const paramObj = {
          entityName,
        };
        if (param !== entityName) {
          if (param.includes('(')) {
            const currentParam = param.split('(')[1];
            if (currentParam.includes(')')) {
              paramObj.param = currentParam.slice(0, currentParam.length - 1);
            } else {
              paramObj.param = currentParam;
            }
          } else if (param.includes(')')) {
            paramObj.param = param.slice(0, param.length - 1);
          } else {
            paramObj.param = param.trim();
          }
          if (base) retArr.push(paramObj);
          else {
            const overRelation = getRelationString(
              queryNumber,
              mainEntity,
              entityName,
              rel,
              rel.length
            );
            paramObj.overRelation = overRelation;
            retArr.push(paramObj);
          }
        } else {
          if (base) retArr.push(paramObj);
          else {
            const entity = graphData.find(entity => entity.getName() === param);
            const overRelation = getRelationString(
              queryNumber,
              mainEntity,
              entityName,
              rel,
              rel.length
            );
            entity.getProperties().forEach(prop => {
              const newParamObj = {
                entityName,
                param: prop.getName(),
                overRelation,
              };
              retArr.push(newParamObj);
            });
          }
        }
      });
      return retArr;
    };

    const createRelationsObject = function (
      queryNumber,
      mainEntity,
      targetEntity,
      relations,
      relNames
    ) {
      const retParams = [];
      const targetName = targetEntity.split('|')[0].split('(')[0];
      const relationsArr = relations.split('/');
      const relationsNamesArr = getRelationString(
        queryNumber,
        mainEntity,
        targetName,
        relNames,
        relNames.length
      ).split('/');

      relationsArr.forEach((relationWithParams, index) => {
        const currentRelName = relationsNamesArr[index];
        const params = relationWithParams.split('|');
        params.forEach(param => {
          const paramObj = {
            entityName: currentRelName,
          };
          if (param.includes('(')) {
            const currentParam = param.split('(')[1];
            if (currentParam.includes(')')) {
              paramObj.param = currentParam.slice(0, currentParam.length - 1);
            } else {
              paramObj.param = currentParam;
            }
          } else if (param.includes(')')) {
            paramObj.param = param.slice(0, param.length - 1);
          } else {
            paramObj.param = param.trim();
          }
          retParams.push(paramObj);
        });
      });
      return retParams;
    };

    reader.onload = function (e) {
      const rows = e.target.result.trim().replaceAll('\n', '').split(';');
      rows.forEach(row => {
        if (row !== '') {
          const rowItems = row.split(', ');

          // workload name and aggregate name
          const workloadDetials = rowItems[0].split('(');
          const workloadName = workloadDetials[0];
          const aggregateName = workloadDetials[1];
          const currentWorkload = new Query(workloadName, aggregateName);

          //LS Parameters
          const cleanedlsParams = rowItems[1].slice(1, rowItems[1].length - 1);
          if (cleanedlsParams !== '') {
            const lsParams = cleanedlsParams.split(',');
            lsParams.forEach(param => {
              const paramDetails = param.split('_')[0];
              const parmRel = param.split('_')[1];
              let detailObj;
              if (parmRel === '!') {
                detailObj = createObject(
                  currentWorkload.getName(),
                  currentWorkload.getAggregateName(),
                  paramDetails
                );
              } else if (parmRel.includes('(')) {
                const relName = parmRel
                  .split('/')
                  .map(currentRel => currentRel[0])
                  .join('');

                detailObj = createObject(
                  currentWorkload.getName(),
                  currentWorkload.getAggregateName(),
                  paramDetails,
                  relName,
                  false
                );

                const relationsObj = createRelationsObject(
                  currentWorkload.getName(),
                  currentWorkload.getAggregateName(),
                  paramDetails,
                  parmRel,
                  relName
                );

                detailObj = [...detailObj, ...relationsObj];
              } else {
                detailObj = createObject(
                  currentWorkload.getName(),
                  currentWorkload.getAggregateName(),
                  paramDetails,
                  parmRel,
                  false
                );
              }

              currentWorkload.addLSList(detailObj);
            });
          }

          //LP Parameters
          const cleanedlpParams = rowItems[2].slice(1, rowItems[2].length - 2);
          if (cleanedlpParams !== '') {
            const lpParams = cleanedlpParams.split(',');
            lpParams.forEach(param => {
              const paramDetails = param.split('_')[0];
              const parmRel = param.split('_')[1];
              let detailObj;
              if (parmRel === '!') {
                detailObj = createObject(
                  currentWorkload.getName(),
                  currentWorkload.getAggregateName(),
                  paramDetails
                );
              } else if (parmRel.includes('(')) {
                const relName = parmRel
                  .split('/')
                  .map(currentRel => currentRel[0])
                  .join('');

                detailObj = createObject(
                  currentWorkload.getName(),
                  currentWorkload.getAggregateName(),
                  paramDetails,
                  relName,
                  false
                );

                const relationsObj = createRelationsObject(
                  currentWorkload.getName(),
                  currentWorkload.getAggregateName(),
                  paramDetails,
                  parmRel,
                  relName
                );

                detailObj = [...detailObj, ...relationsObj];
              } else {
                detailObj = createObject(
                  currentWorkload.getName(),
                  currentWorkload.getAggregateName(),
                  paramDetails,
                  parmRel,
                  false
                );
              }
              currentWorkload.addLPList(detailObj);
            });
          }

          // add new workload
          workloads.push(currentWorkload);
        }
      });
      console.log(workloads);
      alert('Workloads are loaded successfully');
    };
    reader.readAsText(file);
  }
});

newGraphForm.addEventListener('submit', function (e) {
  e.preventDefault();
  graph.clear();
  graphData.splice(0, graphData.length);
  workloads.splice(0, workloads.length);
  linkAnnotations.splice(0, linkAnnotations.length);
  selectedChild = null;
  annotate = false;
  dropDownlists.forEach(list => {
    list.innerHTML = '';
  });
});

saveGraphForm.addEventListener('submit', function (e) {
  e.preventDefault();
  const savedGraphData = new SavedGraph();

  graphData.forEach(data => {
    if (data instanceof Entity) {
      savedGraphData.Entities.push(data.getSavedObject());
    } else if (data instanceof Relation) {
      savedGraphData.Relations.push(data.getSavedObject());
    }

    data.getConnections().forEach(connection => {
      const conn = savedGraphData.connections.find(
        d =>
          (d?.elm1 === connection.getEntity().getName() &&
            d?.elm2 === data.getName()) ||
          (d?.elm1 === data.getName() &&
            d?.elm2 === connection.getEntity().getName())
      );
      if (!conn) {
        const connObj = {
          type: connection.getType(),
          elm1: data.getName(),
          elm2: connection.getEntity().getName(),
        };
        savedGraphData.connections.push(connObj);
      }
    });
  });
  downloadData(savedGraphData);
});

loadGraphForm.addEventListener('submit', function (e) {
  e.preventDefault();
  graph.clear();
  graphData.splice(0, graphData.length);
  const formData = Object.fromEntries([...new FormData(this)]);
  const file = formData.schema;
  const reader = new FileReader();

  reader.onload = function (e) {
    const data = JSON.parse(e.target.result);
    const entitiesAndRelations = [...data.Entities, ...data.Relations];

    entitiesAndRelations.forEach(entity => {
      //Handel Entity
      const graphEntity =
        entity.type === 'Entity'
          ? erd.createEntity(entity.name, entity.position)
          : erd.createRelation(entity.name, entity.position);
      graph.addCell(graphEntity);

      const dataEntity =
        entity.type === 'Entity'
          ? new Entity(graphEntity.id, entity.name, entity.position)
          : new Relation(graphEntity.id, entity.name, entity.position);

      updateDropDownlist(
        dataEntity.getId(),
        dataEntity.getType(),
        dataEntity.getName()
      );

      //Handel Properties
      entity.properties.forEach(prop => {
        let graphProp;
        if (prop.isPrimary) {
          graphProp = erd.createKey(prop.name, prop.position);
        } else {
          graphProp = erd.createNormalPropoerty(prop.name, prop.position);
        }
        //Add Property to Graph with link Creation
        graph.addCell(graphProp);
        erd.createLink(graphEntity, graphProp, graph);

        const propData = new Property(
          graphProp.id,
          prop.name,
          prop.type.toLowerCase(),
          prop.position,
          prop.isPrimary,
          dataEntity,
          prop.isOptional
        );
        dataEntity.addProperty(propData);
      });

      entity.connectors.forEach(connector => {
        const connectorCell = erd.createPrimaryConnector(connector.position);
        const connectorData = new Connector(
          connectorCell.id,
          connector.position
        );
        graph.addCell(connectorCell);

        connector.keys.forEach(keyName => {
          const prop = dataEntity
            .getProperties()
            .find(prop => prop.getName() === keyName);

          if (prop) {
            prop.setConnector(connectorData);
            connectorData.addNewPrimaryKey(prop);

            const propCell = graph.getCell(prop.getId());
            erd.createLink(connectorCell, propCell, graph);
          }
        });
      });
      graphData.push(dataEntity);
    });

    data.connections.forEach(connection => {
      const { type, elm1, elm2 } = connection;

      //Get Elements
      const elm1Entity = graphData.find(d => d.getName() === elm1);
      const elm2Entity = graphData.find(d => d.getName() === elm2);

      //Create Connection
      const elm1Connection = new Connection(type, elm2Entity);
      elm1Entity.addConnection(elm1Connection);

      const elm2Connection = new Connection(type, elm1Entity);
      elm2Entity.addConnection(elm2Connection);

      if (elm1Entity instanceof Relation) {
        erd
          .createLink(elm2Entity, elm1Entity, graph)
          .set(erd.createLabel(type));
      } else {
        erd
          .createLink(elm1Entity, elm2Entity, graph)
          .set(erd.createLabel(type));
      }
    });
  };

  reader.readAsText(file);
});

schemaAnnotationButton.addEventListener('click', function (e) {
  e.preventDefault();
  // console.log(workloads);
  // console.log(linkAnnotations);
  if (graphData.length === 0 || workloads.length === 0) {
    alert(
      'Please note that you should add graph entities or upload workload file to start the annotation process'
    );
  } else {
    if (!annotate) {
      workloads.forEach(query => {
        const entity = graphData.find(
          elm => elm.getName() === query.getAggregateName()
        );

        // Annotate The model Entity
        if (entity) {
          entity.setAsAnnotated();
          if (entity.getAnnotatedName() === '') {
            entity.setAnnotatedName(`${query.getName()} - ${entity.getName()}`);
          } else {
            const annotationName = entity.getAnnotatedName().split(' - ');
            const annotation = `${annotationName[0]},${query.getName()}`;
            entity.setAnnotatedName(`${annotation} - ${entity.getName()}`);
          }

          // Annotate LS properties
          query.getLSParams().forEach(prop => {
            let paramName = '',
              eOrD = '';
            if (prop.param) {
              const nameAnnotation = prop.param.split(':');
              paramName = nameAnnotation[0];
              if (nameAnnotation.length === 2) {
                eOrD = nameAnnotation[1].toLowerCase() === 'e' ? 'E' : 'I';
              }
            }
            if (prop.entityName === entity.getName()) {
              const currentProp = entity
                .getProperties()
                .find(entityProp => entityProp.getName() === paramName);

              if (currentProp) {
                currentProp.setAsAnnotated();
                currentProp.addLSAnnotationName(`${query.getName()}-S${eOrD}`);
              }
            } else {
              const propEntity = graphData.find(
                elm => elm.getName() === prop.entityName
              );
              if (propEntity) {
                const currentProp = propEntity
                  .getProperties()
                  .find(entityProp => entityProp.getName() === paramName);
                if (currentProp) {
                  currentProp.setAsAnnotated();
                  currentProp.addLSAnnotationName(
                    `${query.getName()}-S${eOrD}`
                  );
                }
              }
            }
          });

          // Annotate LP properties
          query.getLPParams().forEach(prop => {
            if (prop.entityName === entity.getName() && prop.param) {
              const currentProp = entity
                .getProperties()
                .find(entityProp => entityProp.getName() === prop.param);

              if (currentProp) {
                currentProp.setAsAnnotated();
                currentProp.addLPAnnotationName(`${query.getName()}-P`);
              }
            } else {
              const propEntity = graphData.find(
                elm => elm.getName() === prop.entityName
              );
              if (propEntity) {
                const currentProp = propEntity
                  .getProperties()
                  .find(entityProp => entityProp.getName() === prop.param);
                if (currentProp) {
                  currentProp.setAsAnnotated();
                  currentProp.addLPAnnotationName(`${query.getName()}-P`);
                }
              }
            }
          });
        }
      });
      addGraphAnnotation();
      addLinkAnnotation();
      annotate = true;
    } else {
      alert('Schema is already annotated.');
    }
  }
});

nestedRelationalSchemaButton.addEventListener('click', function (e) {
  e.preventDefault();

  const addNormalAttributeToAggregate = function (
    aggregate,
    attributeName,
    attributeType,
    attributeIsOptional,
    attributeDescription,
    attributeFrom
  ) {
    const propName = `${attributeFrom.toLowerCase()}${attributeName[0].toUpperCase()}${attributeName.substring(
      1
    )}`;
    if (!aggregate.getPropertiesAt(propName)) {
      aggregate.addNewProperty(
        propName,
        new NormalType(attributeType, attributeDescription),
        attributeIsOptional
      );
    }
  };

  const addPropertyToNestedAttribute = function (
    aggregate,
    nestedAttributeName,
    attributeName,
    attributeType,
    attributeIsOptional,
    attributeDescription,
    attributeFrom,
    minItems
  ) {
    if (!aggregate.getPropertiesAt(nestedAttributeName)) {
      const newArray = new ArrayType(minItems);
      newArray.setItemsObject(new ObjectType());
      aggregate.addNewProperty(nestedAttributeName, newArray);
    }

    const newArray = aggregate.getPropertiesAt(nestedAttributeName);
    addNormalAttributeToAggregate(
      newArray.getItemsObj(),
      attributeName,
      attributeType,
      attributeIsOptional,
      attributeDescription,
      attributeFrom
    );
  };

  const getNumberOfAddedProps = function (primaryKeys, addedProps) {
    const numberOfAddedProps = new Array(primaryKeys.length).fill(0);
    primaryKeys.forEach((prop, index) => {
      if (addedProps[index]) {
        if (prop.getConnector()) {
          const connector = prop.getConnector();
          connector
            .getPrimaryKeys()
            .filter(key => key.getId() !== prop.getId())
            .forEach(key => {
              const ind = primaryKeys.findIndex(
                keyProp => keyProp.getId() === key.getId()
              );
              if (addedProps[ind] === false) {
                numberOfAddedProps[index]++;
              }
            });
        }
      } else {
        numberOfAddedProps[index] = -1;
      }
    });
    return numberOfAddedProps;
  };

  const checkPrimaries = function (aggregate) {
    const aggEntity = graphData.find(
      ent => ent.getName() === aggregate.getTitle()
    );

    if (!aggEntity) return;
    const primaryKeys = aggEntity
      .getProperties()
      .filter(prop => prop.getIsPrimary());
    const primaryKeysNames = primaryKeys.map(
      prop =>
        `${aggEntity.getName().toLowerCase()}${prop
          .getName()[0]
          .toUpperCase()}${prop.getName().substring(1)}`
    );
    const addedProps = [];
    primaryKeys.forEach((_, index) => {
      const addedProp = aggregate.getPropertiesAt(primaryKeysNames[index])
        ? true
        : false;
      addedProps.push(addedProp);
    });

    if (addedProps.filter(isAdded => isAdded === true).length === 0) {
      const neededKey = primaryKeys.find(key => !key.getConnector());
      if (neededKey) {
        addNormalAttributeToAggregate(
          aggregate,
          neededKey.getName(),
          neededKey.getType(),
          neededKey.getIsOptional(),
          Helper.EQUALITY,
          aggEntity.getName()
        );
        const propName = `${aggEntity.getName().toLowerCase()}${neededKey
          .getName()[0]
          .toUpperCase()}${neededKey.getName().substring(1)}`;
        aggregate.addPrimaryKey(propName);
      }
    } else {
      const numberOfAddedProps = getNumberOfAddedProps(primaryKeys, addedProps);
      let index = -1,
        value;
      for (let i = 0; i < numberOfAddedProps.length; i++) {
        if (value) {
          if (numberOfAddedProps[i] !== -1 && value > numberOfAddedProps[i]) {
            index = i;
            value = numberOfAddedProps[i];
          }
        } else {
          if (numberOfAddedProps[i] !== -1) {
            index = i;
            value = numberOfAddedProps[i];
          }
        }
      }
      if (index !== -1) {
        if (value >= 1) {
          const keyProp = primaryKeys[index];
          if (keyProp.getConnector()) {
            keyProp
              .getConnector()
              .getPrimaryKeys()
              .forEach(key => {
                addNormalAttributeToAggregate(
                  aggregate,
                  key.getName(),
                  key.getType(),
                  key.getIsOptional(),
                  Helper.EQUALITY,
                  aggEntity.getName()
                );
                const keyName = `${aggEntity.getName().toLowerCase()}${key
                  .getName()[0]
                  .toUpperCase()}${key.getName().substring(1)}`;
                aggregate.addPrimaryKey(keyName);
              });
          } else {
            addNormalAttributeToAggregate(
              aggregate,
              keyProp.getName(),
              keyProp.getType(),
              keyProp.getIsOptional(),
              Helper.EQUALITY,
              aggEntity.getName()
            );
            const keyName = `${aggEntity.getName().toLowerCase()}${keyProp
              .getName()[0]
              .toUpperCase()}${keyProp.getName().substring(1)}`;
            aggregate.addPrimaryKey(keyName);
          }
        } else {
          const keyProp = primaryKeys[index];
          if (keyProp.getConnector()) {
            keyProp
              .getConnector()
              .getPrimaryKeys()
              .forEach(key => {
                const keyName = `${aggEntity.getName().toLowerCase()}${key
                  .getName()[0]
                  .toUpperCase()}${key.getName().substring(1)}`;
                aggregate.addPrimaryKey(keyName);
              });
          } else {
            const keyName = `${aggEntity.getName().toLowerCase()}${keyProp
              .getName()[0]
              .toUpperCase()}${keyProp.getName().substring(1)}`;
            aggregate.addPrimaryKey(keyName);
          }
        }
      }
    }
  };

  if (annotate) {
    allJSONSchema.splice(0, allJSONSchema.length);
    //Getting the existed aggregates names
    const existedAggregates = new Set(
      workloads.map(workload => workload.getAggregateName())
    );

    existedAggregates.forEach(aggregateName => {
      //Create a new Aggregate Schema
      const currentSchema = new JSONSchema(aggregateName);

      //Get the related Queries
      const relatedWorkload = workloads.filter(
        workload => workload.getAggregateName() === aggregateName
      );
      relatedWorkload.forEach(currentQuery => {
        // Spreding the query params
        const allParams = currentQuery.getAllParams();
        // Getting the entity names for the params
        const paramsEntityNames = new Set(
          allParams.map(param => param.entityName)
        );
        //Looping the entity names
        paramsEntityNames.forEach(entityName => {
          // Getting the paramms that are related to an entity
          const entityParams = allParams.filter(
            param => param.entityName === entityName
          );
          // Finding the Related Entity
          const relatedEntity = graphData.find(
            entity => entity.getName() === entityName
          );

          entityParams.forEach(currentParam => {
            // Params deltails
            const paramDetails = currentParam.param.split(':');
            const paramName = paramDetails[0];
            const paramDesc =
              paramDetails.length === 2
                ? paramDetails[1].toLowerCase() === 'e'
                  ? Helper.EQUALITY
                  : Helper.INEQUALITY
                : '';
            // Get the needed property
            const relatedProp = relatedEntity
              .getProperties()
              .find(prop => prop.getName() === paramName);

            // If they are the same entity
            if (entityName === currentSchema.getTitle()) {
              if (relatedProp) {
                addNormalAttributeToAggregate(
                  currentSchema,
                  relatedProp.getName(),
                  relatedProp.getType(),
                  relatedProp.getIsOptional(),
                  paramDesc,
                  relatedEntity.getName()
                );
              }
            }
            // If they are not the same entity
            else {
              // If there are relations between the connected entities
              if (currentParam?.overRelation) {
                const path = currentParam.overRelation.split('/');

                let currentEntity = graphData.find(
                  entity => entity.getName() === aggregateName
                );
                let addedTo = currentSchema;
                for (
                  let index = path.length - 1;
                  index >= 0;
                  index = index - 2
                ) {
                  const connection = currentEntity
                    .getConnections()
                    .find(
                      connection =>
                        connection.getEntity().getName() === path[index]
                    );

                  if (
                    connection.getType() === Helper.ONE_TO_MANY ||
                    connection.getType() === Helper.ZERO_TO_MANY
                  ) {
                    let newAddedTo = addedTo.getPropertiesAt(path[index]);
                    if (!newAddedTo) {
                      const minItems =
                        connection.getType() === Helper.ONE_TO_MANY ? 1 : 0;
                      newAddedTo = new ArrayType(minItems);
                      newAddedTo.setItemsObject(new ObjectType());
                      addedTo.addNewProperty(path[index], newAddedTo);
                    }
                    addedTo = newAddedTo.getItemsObj();
                  }
                  if (index > 0)
                    currentEntity = graphData.find(
                      entity => entity.getName() === path[index - 1]
                    );
                }
                addNormalAttributeToAggregate(
                  addedTo,
                  relatedProp.getName(),
                  relatedProp.getType(),
                  relatedProp.getIsOptional(),
                  paramDesc,
                  relatedEntity.getName()
                );
              }
              // If they are directly connected
              else {
                // get the connection
                const relatedConnection = relatedEntity
                  .getConnections()
                  .find(
                    connection =>
                      connection.getEntity().getName() ===
                      currentSchema.getTitle()
                  );
                // check the connection type
                //If One to Many or Zero to Many
                if (
                  relatedConnection.getType() === Helper.ONE_TO_MANY ||
                  relatedConnection.getType() === Helper.ZERO_TO_MANY
                ) {
                  addPropertyToNestedAttribute(
                    currentSchema,
                    relatedEntity.getName(),
                    relatedProp.getName(),
                    relatedProp.getType(),
                    relatedProp.getIsOptional(),
                    paramDesc,
                    relatedEntity.getName(),
                    relatedConnection.getType() === Helper.ONE_TO_MANY ? 1 : 0
                  );
                } //If Not One to Many or Zero to Many
                else {
                  addNormalAttributeToAggregate(
                    currentSchema,
                    relatedProp.getName(),
                    relatedProp.getType(),
                    relatedProp.getIsOptional(),
                    paramDesc,
                    relatedEntity.getName()
                  );
                }
              }
            }
          });
        });
      });
      checkPrimaries(currentSchema);
      // console.log(currentSchema);
      allJSONSchema.push(currentSchema);
      downloadData(currentSchema, `${currentSchema.getTitle()}Schema`);
    });
  } else {
    alert('You should have annotated schema to generate JSON Schema');
  }
});

codeGenerationButton.addEventListener('click', function (e) {
  e.preventDefault();

  // Creating Groups functions
  const checkCurrentGroup = function (groups, group) {
    for (let index = 0; index < groups.length; index++) {
      const currentGroup = groups[index];
      if (
        Helper.areSetsEqual(currentGroup, group) ||
        Helper.set2ContainSet1(group, currentGroup)
      ) {
        return groups;
      } else if (Helper.set2ContainSet1(currentGroup, group)) {
        groups[index] = group;
        return groups;
      }
    }
    groups.push(group);
    return groups;
  };

  const getLSParamsGroups = function (relatedWorkload) {
    let lsGroups = [];
    relatedWorkload.forEach(workload => {
      if (workload.getLSParams().length !== 0) {
        lsGroups.push(
          workload.getLSParams().map(param => {
            const paramData = param.param.split(':');
            return {
              entityName: param.entityName,
              paramName: paramData[0],
              constraint: paramData[1],
              overRelation: param.overRelation,
            };
          })
        );
      }
    });
    lsGroups = lsGroups.map(group => new Set(group));
    let lsFinalGroups = [];
    lsGroups.forEach(group => {
      if (lsFinalGroups.length === 0) {
        lsFinalGroups.push(group);
      } else {
        lsFinalGroups = checkCurrentGroup(lsFinalGroups, group);
      }
    });
    return [lsGroups, lsFinalGroups];
  };

  // Create DB Objects

  const createTable = function (jsonSchema) {
    const currentTable = new Table(jsonSchema.getTitle());
    const properties = Object.keys(jsonSchema.getProperties());
    properties.forEach(key => {
      const propObject = jsonSchema.getPropertiesAt(key);
      let tableProp;
      if (propObject['type'] !== 'array') {
        tableProp = new TableProperty(key, propObject['type']);
      } else {
        const properties = propObject['items']['properties'];
        const keys = Object.keys(properties);
        const neededProp = properties[keys[0]];
        tableProp = new TableProperty(
          keys[0],
          `list<${neededProp['type']}>`,
          true
        );
      }
      currentTable.addProperty(tableProp);
    });
    // currentTable.addPrimaryKeyArray(jsonSchema.getPrimaryKey());
    return currentTable;
  };

  const getNormalizedProperties = function (obj) {
    let returnProperties = [];
    let properties;
    if (obj['type'] === 'object') {
      properties = obj['properties'];
    } else if (obj['type'] === 'array') {
      properties = obj['items']['properties'];
    }
    const propertiesNames = Object.keys(properties);
    propertiesNames.forEach(key => {
      const propObject = properties[key];
      if (propObject['type'] !== 'array') {
        returnProperties.push(new TableProperty(key, propObject['type']));
      } else {
        const arrayProps = getNormalizedProperties(propObject);
        returnProperties = [...returnProperties, ...arrayProps];
      }
    });
    return returnProperties;
  };

  const createNormalizedTable = function (jsonSchema) {
    const currentTable = new Table(jsonSchema.getTitle());
    currentTable.addProperty(new TableProperty('nID', 'string'));

    const normalizedProperties = getNormalizedProperties(jsonSchema);
    normalizedProperties.forEach(prop => {
      currentTable.addProperty(prop);
    });

    return currentTable;
  };

  const createTableFor = function (
    entity,
    jsonSchema,
    isAttributesNormalized = true
  ) {
    let currentTable;

    if (isAttributesNormalized) {
      currentTable = new Table(entity.getName());
      const normalizedProperties = getNormalizedProperties(jsonSchema);
      normalizedProperties.forEach(prop => {
        currentTable.addProperty(prop);
      });
    } else {
      currentTable = new Table(entity.getName());

      const properties = Object.keys(jsonSchema.getProperties());
      properties.forEach(key => {
        const propObject = jsonSchema.getPropertiesAt(key);
        let tableProp;
        if (propObject['type'] !== 'array') {
          tableProp = new TableProperty(key, propObject['type']);
          currentTable.addProperty(tableProp);
        } else {
          const properties = propObject['items']['properties'];
          const keys = Object.keys(properties);
          if (keys.length === 1) {
            const neededProp = properties[keys[0]];
            tableProp = new TableProperty(
              keys[0],
              `list<${neededProp['type']}>`,
              true
            );
            currentTable.addProperty(tableProp);
          } else {
            keys.forEach(name => {
              const neededProp = properties[name];
              const tablePropNew = new TableProperty(name, neededProp['type']);
              currentTable.addProperty(tablePropNew);
            });
          }
        }
      });
    }

    return currentTable;
  };

  const createTempSchemas = function (currentJson, relatedWorkload) {
    const tempSchames = [];
    relatedWorkload.forEach(query => {
      const allQueryParams = [...query.getLSParams(), ...query.getLPParams()];
      const newSchema = new JSONSchema(currentJson.getTitle());

      allQueryParams.forEach(param => {
        const [name, neededProp] = currentJson.getSpecificProp(param);
        if (!newSchema.getPropertiesAt(name))
          newSchema.addNewProperty(name, neededProp);
      });
      currentJson.getPrimaryKey().forEach(key => {
        if (!newSchema.getPropertiesAt(key)) {
          const prop = currentJson.getPropertiesAt(key);
          newSchema.addNewProperty(key, prop);
          newSchema.addPrimaryKey(key);
        }
      });
      tempSchames.push([newSchema, [query]]);
    });
    return tempSchames;
  };

  const joinTempSchemas = function (tempSchames) {
    const finalSchemas = [];
    const isJoint = Array(tempSchames.length).fill(false);
    for (let index = 0; index < tempSchames.length; index++) {
      if (!isJoint[index]) {
        const currentItem = tempSchames[index];
        const currentSchema = currentItem[0];
        const relatedWorkload = [...currentItem[1]];
        for (let counter = index + 1; counter < tempSchames.length; counter++) {
          const jointItem = tempSchames[counter];
          if (currentItem[0].canBeJoint(jointItem[0])) {
            isJoint[counter] = true;
            jointItem[1].forEach(item => {
              relatedWorkload.push(item);
            });
            currentSchema.joinSchema(jointItem[0]);
          } else if (jointItem[0].canBeJoint(currentItem[0])) {
            isJoint[counter] = true;
            jointItem[1].forEach(item => {
              relatedWorkload.push(item);
            });
            currentSchema.joinSchema(jointItem[0]);
          }
        }
        finalSchemas.push([currentSchema, relatedWorkload]);
      }
    }
    if (finalSchemas.length < tempSchames.length) {
      return joinTempSchemas(finalSchemas);
    } else {
      console.log(finalSchemas);
      return finalSchemas;
    }
  };

  const regenerateSchemas = function (currentJson, relatedWorkload) {
    const tempSchames = createTempSchemas(currentJson, relatedWorkload);
    // console.log(tempSchames);
    const finalItems = joinTempSchemas(tempSchames);
    // console.log(finalItems);
    return finalItems;
  };

  // checking params

  const getParams = function (relatedWorkload) {
    const lsParams = [];
    const lpParams = [];

    relatedWorkload.forEach(query => {
      query.getLSParams().forEach(lsParam => {
        lsParams.push(lsParam);
      });

      query.getLPParams().forEach(lpParam => {
        lpParams.push(lpParam);
      });
    });

    return [lsParams, lpParams];
  };

  const getNeededEntityNames = function (nestedAttribute, allParams) {
    const paramsNames = Object.keys(nestedAttribute['items']['properties']);
    const paramsObj = allParams.filter(param => {
      const paramName = param.param.split(':')[0];
      const savedName =
        param.entityName.toLowerCase() +
        paramName[0].toUpperCase() +
        paramName.substring(1);
      return savedName === paramsNames[0];
    });
    if (paramsObj.length > 0) {
      const paramObj = paramsObj[0];
      const betweenObj = paramObj.overRelation.split('/');
      if (betweenObj.length > 1) {
        return [
          betweenObj[betweenObj.length - 1],
          betweenObj[betweenObj.length - 2],
        ];
      } else {
        return [betweenObj[0], paramObj.entityName];
      }
    }
  };

  const checkPrimaryKeys = function (currentTable, entity) {
    let tablePKs = [];
    const pkProperties = entity
      .getProperties()
      .filter(property => property.getIsPrimary());

    if (pkProperties.length > 0) {
      // get already added primary keys
      const addedPrimaries = [];
      for (let index = 0; index < pkProperties.length; index++) {
        const currentKey = pkProperties[index];
        const addedName =
          entity.getName().toLowerCase() +
          currentKey.getName()[0].toUpperCase() +
          currentKey.getName().substring(1);

        const tableProp = currentTable.getSpecificProp(addedName);
        if (tableProp) {
          addedPrimaries.push(currentKey);
        }
      }

      if (addedPrimaries.length === 0) {
        const simplePK = pkProperties.filter(
          property => !property.getConnector()
        );
        if (simplePK.length === 0) {
          const firstPK = pkProperties[0];
          firstPK
            .getConnector()
            .getPrimaryKeys()
            .forEach(prop => {
              const addedName =
                entity.getName().toLowerCase() +
                prop.getName()[0].toUpperCase() +
                prop.getName().substring(1);

              const tableProp = currentTable.getSpecificProp(addedName);
              if (!tableProp) {
                currentTable.addProperty(
                  new TableProperty(addedName, prop.getType())
                );
              }
              tablePKs.push(addedName);
            });
        } else {
          const simpleKey = simplePK[0];
          const addedName =
            entity.getName().toLowerCase() +
            simpleKey.getName()[0].toUpperCase() +
            simpleKey.getName().substring(1);

          currentTable.addProperty(
            new TableProperty(addedName, simpleKey.getType())
          );

          tablePKs.push(addedName);
        }
      } else {
        const addedSimpleKeys = addedPrimaries.filter(
          property => !property.getConnector()
        );
        if (addedSimpleKeys.length === 0) {
          const firstPK = addedPrimaries[0];
          firstPK
            .getConnector()
            .getPrimaryKeys()
            .forEach(prop => {
              const addedName =
                entity.getName().toLowerCase() +
                prop.getName()[0].toUpperCase() +
                prop.getName().substring(1);

              const tableProp = currentTable.getSpecificProp(addedName);
              if (!tableProp) {
                currentTable.addProperty(
                  new TableProperty(addedName, prop.getType())
                );
              }
              tablePKs.push(addedName);
            });
        } else {
          const simpleKey = addedSimpleKeys[0];
          const addedName =
            entity.getName().toLowerCase() +
            simpleKey.getName()[0].toUpperCase() +
            simpleKey.getName().substring(1);
          tablePKs.push(addedName);
        }
      }
    }
    return tablePKs;
  };

  const getPrimaryKeys = function (currentTable, entities) {
    // console.log(entities);
    let pkNames = [];
    entities.forEach(entity => {
      const names = checkPrimaryKeys(currentTable, entity);
      pkNames = [...pkNames, ...names];
    });
    return pkNames;
  };

  const checkingParams = function (
    currentJson,
    relatedWorkload,
    numberOfNestedAttributes,
    numberOfattributes
  ) {
    const [allLSParams, allLPParams] = getParams(relatedWorkload);
    const allParams = [...allLSParams, ...allLPParams];
    const nestedParams = currentJson.getNestedParameters();
    // Number of Nested Attributes is 1
    if (numberOfNestedAttributes === 1) {
      const currentNestedParam = nestedParams[0];
      // If all the nested attributes are simple
      if (currentJson.isSimpleNestedParam(currentNestedParam)) {
        const [betweenRelName, neededEntityName] = getNeededEntityNames(
          currentNestedParam,
          allParams
        );

        const mainEntity = graphData.find(
          entity => entity.getName() === currentJson.getTitle()
        );

        const neededEntity = graphData.find(
          entity => entity.getName() === neededEntityName
        );

        const paramEntityConnection = neededEntity
          .getConnections()
          .find(
            connection => connection.getEntity().getName() === betweenRelName
          );

        let createdTable;
        let primaries;
        if (
          paramEntityConnection.getType() === Helper.ONE_TO_ONE ||
          paramEntityConnection.getType() === Helper.ZERO_TO_ONE
        ) {
          createdTable = createTableFor(neededEntity, currentJson);
          primaries = getPrimaryKeys(createdTable, [neededEntity]);
        } else {
          createdTable = createTableFor(
            paramEntityConnection.getEntity(),
            currentJson
          );
          primaries = getPrimaryKeys(createdTable, [
            paramEntityConnection.getEntity(),
          ]);
          if (primaries.length === 0) {
            primaries = getPrimaryKeys(createdTable, [
              neededEntity,
              mainEntity,
            ]);
          }
        }
        const admittedTables = checkAdmitted(
          createdTable,
          currentJson,
          relatedWorkload,
          primaries
        );
        return admittedTables;
      }
      // If the nested attributes are not simple
      else {
        const createdTable = createNormalizedTable(currentJson);
        const admittedTables = checkAdmitted(
          createdTable,
          currentJson,
          relatedWorkload,
          ['nID']
        );
        return admittedTables;
      }
    }
    // If there are more that one nested attribute
    else {
      const simpleNestedAttributes = currentJson.getSimpleNestedAttributes();
      if (simpleNestedAttributes.length > 0) {
        if (numberOfattributes.every(item => item === 1)) {
          const createdTable = createTable(currentJson);

          const mainEntity = graphData.find(
            entity => entity.getName() === currentJson.getTitle()
          );

          const primaries = getPrimaryKeys(createdTable, [mainEntity]);

          const admmittedTable = checkAdmitted(
            createdTable,
            currentJson,
            relatedWorkload,
            primaries
          );
          return admmittedTable;
        } else if (simpleNestedAttributes.length === nestedParams.length) {
          const filterNumberOfAttributes = numberOfattributes.filter(
            item => item > 1
          );
          if (filterNumberOfAttributes.length === 1) {
            const index = numberOfattributes.findIndex(item => item > 1);
            const currentNestedParam = nestedParams[index];

            const [betweenRelName, neededEntityName] = getNeededEntityNames(
              currentNestedParam,
              allParams
            );

            const mainEntity = graphData.find(
              entity => entity.getName() === currentJson.getTitle()
            );

            const neededEntity = graphData.find(
              entity => entity.getName() === neededEntityName
            );

            const paramEntityConnection = neededEntity
              .getConnections()
              .find(
                connection =>
                  connection.getEntity().getName() === betweenRelName
              );

            let createdTable;
            let primaries;
            if (
              paramEntityConnection.getType() === Helper.ONE_TO_ONE ||
              paramEntityConnection.getType() === Helper.ZERO_TO_ONE
            ) {
              createdTable = createTableFor(neededEntity, currentJson, false);
              primaries = getPrimaryKeys(createdTable, [neededEntity]);
            } else {
              createdTable = createTableFor(
                paramEntityConnection.getEntity(),
                currentJson,
                false
              );
              primaries = getPrimaryKeys(createdTable, [
                paramEntityConnection.getEntity(),
              ]);
              if (primaries.length === 0) {
                primaries = getPrimaryKeys(createdTable, [
                  neededEntity,
                  mainEntity,
                ]);
              }
            }
            const admittedTables = checkAdmitted(
              createdTable,
              currentJson,
              relatedWorkload,
              primaries
            );
            return admittedTables;
          } else {
            const newSchemas = regenerateSchemas(currentJson, relatedWorkload);
            let tables = [];
            newSchemas.forEach(newSchema => {
              let table;
              const [
                newSchemaNumberOfNestedAttributes,
                newSchemaNumberOfattributes,
              ] = newSchema[0].checkingNestedParams();
              if (
                newSchemaNumberOfNestedAttributes <= 1 ||
                newSchemaNumberOfattributes.every(item => item === 1)
              ) {
                table = checkingParams(
                  newSchema[0],
                  newSchema[1],
                  newSchemaNumberOfNestedAttributes,
                  newSchemaNumberOfattributes
                );
                tables = [...tables, ...table];
              } else {
                const newFilterNumberOfAttributes =
                  newSchemaNumberOfattributes.filter(item => item > 1);
                if (newFilterNumberOfAttributes.length === 1) {
                  table = checkingParams(
                    newSchema[0],
                    newSchema[1],
                    newSchemaNumberOfNestedAttributes,
                    newSchemaNumberOfattributes
                  );
                  tables = [...tables, ...table];
                } else {
                  table = createNormalizedTable(newSchema[0]);
                  const admittedTables = checkAdmitted(
                    table,
                    currentJson,
                    newSchema[1],
                    ['nID']
                  );
                  tables = [...tables, ...admittedTables];
                }
              }
            });
            return tables;
          }
        } else {
          const createdTable = createNormalizedTable(currentJson);
          const admittedTables = checkAdmitted(
            createdTable,
            currentJson,
            relatedWorkload,
            ['nID']
          );
          return admittedTables;
        }
      } else {
        const createdTable = createNormalizedTable(currentJson);
        const admittedTables = checkAdmitted(
          createdTable,
          currentJson,
          relatedWorkload,
          ['nID']
        );
        return admittedTables;
      }
    }
  };

  // check admitted function

  const checkAdmitted = function (
    currenttTable,
    currentJson,
    relatedWorkload,
    primaryKeys
  ) {
    const [lsGroups, lsFinalGroups] = getLSParamsGroups(relatedWorkload);
    const queryNames = relatedWorkload.map(query => query.getName()).join('');
    // console.log(lsGroups, lsFinalGroups);
    const admittedTables = [];
    if (lsFinalGroups.length > 0) {
      let tableNumber = 1;
      lsFinalGroups.forEach(set => {
        const newTable = currenttTable.getCopy();
        newTable.setName(
          `${newTable.getName()}_${queryNames}${
            lsFinalGroups.length > 1 ? `_${tableNumber}` : ''
          }`
        );
        for (const param of set) {
          const name = `${param.entityName.toLowerCase()}${param.paramName[0].toUpperCase()}${param.paramName.substring(
            1
          )}`;
          const tableProp = newTable.getSpecificProp(name);
          if (tableProp) {
            if (!tableProp.isNested()) {
              if (param.constraint === 'E') {
                newTable.addPrimaryKey(name);
              } else {
                newTable.addNewConstraint(name);
              }
            } else {
              const columnIndex = new DBIndex(
                `IDX_${queryNames}`,
                newTable.getName(),
                tableProp.getName()
              );

              admittedTables.push(columnIndex);
            }
            let idx = 1;
            lsGroups.forEach(group => {
              if (group.size > 0) {
                const indexes = admittedTables.filter(
                  obj => obj instanceof DBIndex
                );
                if (
                  Helper.set2ContainSet1(group, set) &&
                  !Helper.areSetsEqual(group, set)
                ) {
                  for (const groupParam of group) {
                    const groupParamName = `${groupParam.entityName.toLowerCase()}${groupParam.paramName[0].toUpperCase()}${groupParam.paramName.substring(
                      1
                    )}`;

                    const groupParamTableProp =
                      newTable.getSpecificProp(groupParamName);
                    if (groupParamTableProp) {
                      const neededIndex = indexes.find(
                        index =>
                          index.getRelatedColumn() ===
                          groupParamTableProp.getName()
                      );
                      if (!neededIndex) {
                        const columnIndex = new DBIndex(
                          `IDX_${queryNames}_${idx}`,
                          newTable.getName(),
                          groupParamTableProp.getName()
                        );

                        admittedTables.push(columnIndex);
                        idx += 1;
                      }
                    }
                  }
                }
              }
            });
          }
        }
        let pkCopy = [...primaryKeys];
        newTable.addKeysArray(pkCopy);
        tableNumber += 1;
        admittedTables.push(newTable);
      });
    } else {
      currenttTable.addKeysArray(primaryKeys);
      admittedTables.push(currenttTable);
    }
    return admittedTables;
  };

  if (allJSONSchema.length > 0) {
    let dbObjects = [];
    allJSONSchema.forEach(currentJSONSchema => {
      const relatedWorkload = workloads.filter(
        query => query.getAggregateName() === currentJSONSchema.getTitle()
      );
      const [numberOfNestedAttributes, numberOfattributes] =
        currentJSONSchema.checkingNestedParams();
      if (
        numberOfNestedAttributes === 0 ||
        (numberOfNestedAttributes === 1 &&
          numberOfattributes.every(item => item === 1))
      ) {
        const currentTable = createTable(currentJSONSchema);
        const admittedTable = checkAdmitted(
          currentTable,
          currentJSONSchema,
          relatedWorkload,
          currentJSONSchema.getPrimaryKey()
        );
        dbObjects = [...dbObjects, ...admittedTable];
      } else {
        const objects = checkingParams(
          currentJSONSchema,
          relatedWorkload,
          numberOfNestedAttributes,
          numberOfattributes
        );
        if (objects instanceof Array) {
          dbObjects = [...dbObjects, ...objects];
        } else {
          dbObjects.push(objects);
        }
      }
      // console.log(dbObjects);
    });
    let createionstr = '';
    dbObjects.forEach(obj => {
      createionstr += obj.getCreationString() + '\n';
    });
    downloadData(createionstr, 'Tables', 'txt');
  } else {
    alert(
      'You should have generate JSON Schema to proceed with code generation'
    );
  }
});
